import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "CheckoutLogin",
    component: () => (__SERVER__ ? require("./checkout-login-view") : import("./checkout-login-view"))
});

export default definition;
